var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SelectCmp from 'react-select';
import theme from '../theme';
var Select = function (_a) {
    var mode = _a.mode, isMulti = _a.isMulti, isSearchable = _a.isSearchable, placeholder = _a.placeholder, value = _a.value, options = _a.options, onChange = _a.onChange, isClearable = _a.isClearable;
    var customStyles = {
        container: function (p, s) { return (__assign(__assign({}, p), { minWidth: '250px', maxWidth: '400px', background: theme[mode].background, borderRadius: theme.borderRadius, cursor: 'pointer', border: mode === 'dark' ? 'none' : "1px solid " + theme[mode].borderColor, boxSizing: 'border-box', paddingLeft: '5px', '&:hover': {
                borderColor: mode === 'dark' ? 'none' : " " + theme[mode].primaryColor,
                transition: 'all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1)'
            } })); },
        control: function (p, s) { return (__assign(__assign({}, p), { background: 'transparent', border: 'none !important', boxShadow: 'none !important', minHeight: 0 })); },
        placeholder: function (p, s) { return (__assign(__assign({}, p), { color: theme[mode].fontColor, paddingLeft: '5px' })); },
        indicatorSeparator: function () { return ({
            display: 'none'
        }); },
        valueContainer: function (p) { return (__assign(__assign({}, p), { padding: '2px' })); },
        dropdownIndicator: function (p) { return (__assign(__assign({}, p), { color: theme[mode].fontColor, cursor: 'pointer', padding: '4px', '&:hover': {
                color: theme[mode].type === 'dark' ? '#fff' : '#aaa'
            } })); },
        menu: function (p) { return (__assign(__assign({}, p), { background: theme[mode].background, borderRadius: theme.borderRadius, border: 'none', zIndex: 99999 })); },
        singleValue: function (p) { return (__assign(__assign({}, p), { color: theme[mode].fontColor, paddingLeft: '5px' })); },
        multiValue: function (p) { return (__assign(__assign({}, p), { background: theme[mode].primaryColor })); },
        clearIndicator: function (p) { return (__assign(__assign({}, p), { color: theme[mode].fontColor, '&:hover': {
                color: theme[mode].type === 'dark' ? '#fff' : '#aaa',
                cursor: 'pointer'
            } })); },
        multiValueLabel: function (p) { return (__assign(__assign({}, p), { color: '#fff', position: 'relative' })); },
        multiValueRemove: function (p) { return (__assign(__assign({}, p), { color: '#aaa', background: theme[mode].primaryColor, border: 0, '&:hover': {
                background: theme[mode].primaryColor,
                color: '#fff',
                cursor: 'pointer'
            } })); },
        option: function (p) { return (__assign(__assign({}, p), { color: theme[mode].fontColor, background: theme[mode].background, cursor: 'pointer', '&:hover': {
                background: theme[mode].primaryHoverColor,
                color: theme[mode].type === 'dark' ? '#fff' : theme[mode].fontColor
            } })); }
    };
    return (React.createElement(SelectCmp, { isMulti: isMulti, isSearchable: isSearchable, isClearable: isClearable, placeholder: placeholder, value: value, onChange: onChange, options: options, styles: customStyles }));
};
export default Select;
